import { customElement } from 'lit/decorators.js';
import { defaultStagedThreshold, EventCancellation } from '../../../../webmodule-common/other/general/staged-event';
import { notificationSignal } from '../../../../webmodule-common/other/ui/icons/icon-notification-signal';
import {
  ProjectListView,
  ProjectListViewOptions,
  ProjectSummaryTable
} from '../../../projects/views/project-list-view';
import { SSEProject } from '../../../projects/data/sse-project';
import { stagedExecution } from '../../../../webmodule-common/other/general/event-source-client';
import { WMEventSource } from '../../../api/event-source';

@customElement('wm-franchiseeprojectlistview')
export class FranchiseeProjectListView extends ProjectListView {
  constructor(options: ProjectListViewOptions) {
    super(options);
  }
  afterRefresh() {
    this._eventCancel.cancel();
  }
  async dispose(): Promise<void> {
    await super.dispose();
    this._eventCancel.cancel();
  }
  private _eventCancel: EventCancellation = new EventCancellation();
  private _eventProjectUpdated = stagedExecution({
    threshold: defaultStagedThreshold,
    cancelToken: this._eventCancel,
    eventFinally: () => notificationSignal(false),
    event: async () => {
      this.tables.forEach(t => (t.dataIsStale = true));
      const table = this.pageControl.activePage?.data as ProjectSummaryTable;
      this.staleOrders = [];
      if (table) {
        await table.refreshData();
        table.dataIsStale = false;
      }
      //reload the page.. we dont know what moved, or where, or what state its in
    },
    eventTriggered: (_data: SSEProject) => {
      notificationSignal(true);
    },
    eventActioned: (data: SSEProject) => {
      if (!this.staleOrders.includes(data.id)) this.staleOrders.push(data.id);
      const table = this.pageControl.activePage?.data as ProjectSummaryTable;
      table.refreshData();
    }
  });

  connectedCallback(): void {
    super.connectedCallback();
    WMEventSource.getInstance().addEventListener(WMEventSource.project, this._eventProjectUpdated);
  }
  disconnectedCallback(): void {
    super.disconnectedCallback();
    WMEventSource.getInstance().removeEventListener(WMEventSource.project, this._eventProjectUpdated);
  }
}
